import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React, { createContext, useContext } from 'react';
import { initializeSegment } from "../lib/Segment";
import { getCookie, getDeployableInfo } from "../lib/utils";
import { useConstant } from "../hooks/useConstant";
/**
 * Analytics Context
 */

export var AnalyticsContext = /*#__PURE__*/createContext(undefined);
/**
 * Analytics Provider
 */

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      children = _ref.children;
  var analytics = useConstant(function () {
    return initializeSegment({
      debug: debug
    });
  }, [debug]);
  return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
    value: _objectSpread(_objectSpread({}, getDeployableInfo()), {}, {
      deviceId: getCookie('cookie_id'),
      analytics: analytics
    })
  }, children);
};
/**
 *
 * Global Segment Analytics Context Hook
 * @returns context AnalyticsContextValue
 */

export var useSegmentAnalytics = function useSegmentAnalytics() {
  var context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useSegmentAnalytics hook must used within an AnalyticsProvider');
  }

  return context;
};